import { Box, Button, Flex, HStack, Input, InputGroup, InputRightElement, Menu, MenuButton, MenuItem, MenuList, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { BsChevronDown } from 'react-icons/bs'
import { RiSearch2Line } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'
import AdminDashboardHeader from '../../../components/admin/AdminHeader'
import AdminSidebar from '../../../components/admin/AdminSidebar'
import Loading from '../../../components/common/Loading'
import AdminHelpers from '../../../services/admin/admin.service'
import Adminroutes from '../routes'

const Roles = () => {
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [filteredRoles, setFilteredRoles] = useState([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
    const navigate = useNavigate();

    useEffect(()=> {
        AdminHelpers.getRoles().then(
            (res) =>{
                setRoles(res.data);
                setFilteredRoles(res.data);
            }
        )
    },[]);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchTerm = event.target.value.toLowerCase();
        
        if (!searchTerm) {
            setFilteredRoles(roles);
        } else {
          if (roles) {
            const filtered = roles.filter((each: any) => each.name.toLowerCase().includes(searchTerm) );
            setFilteredRoles(filtered);
            
            if (filtered && filtered.length > 0)
              setIsSearchEmpty(false);
            else
              setIsSearchEmpty(true)
          }
        }
    }

    const sortRecentFirst = () => {
        setFilteredRoles([...filteredRoles].sort((a:any,b:any)=> {
            return ((b.created_at > a.created_at) ? 1 : (b.created_at === a.created_at) ? 0 : -1)
        }))
        return filteredRoles;
    };

    const sortOldestFirst = () => {
        setFilteredRoles([...filteredRoles].sort((a:any,b:any)=> {
            return ((a.created_at > b.created_at) ? 1 : (a.created_at === b.created_at) ? 0 : -1)
        }))
        return filteredRoles;
    };

  return (
    <>
        {
            loading ? <Loading /> : 
            <Flex           minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}>
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>

            <Box width='100%'>
                <AdminDashboardHeader />
                <Box               pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden">
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        py="26px"
                    >
                        <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                            Roles
                        </Box>
                        <HStack>
                            <Button colorScheme='red'
                            fontSize='13px'
                            p="7px"
                            borderRadius={"2px"}
                            onClick={()=> navigate(Adminroutes.NewRole)}>
                                CREATE ROLE
                            </Button>
                        </HStack> 
                    </Flex>
                    <Flex py='15px' justifyContent=''>
                        <InputGroup color="brand.subtitle" bg="white"                    width={["90%", "90%", "50%", "30%"]} mr="8px">
                            <Input 
                            height='40px'  
                            placeholder="Search Roles" 
                            fontSize={12} 
                            size="sm" 
                            onChange={(e) => handleSearchChange(e)}
                            />
                            <InputRightElement pointerEvents="none" children={<RiSearch2Line color="red" size="0.9rem" />} />
                        </InputGroup>
                        <HStack spacing='20px'>
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    rightIcon={<BsChevronDown />}
                                    bg='white'
                                    color='#616161'
                                    variant={"outline"}
                                    size="sm"
                                    fontSize={13}
                                    borderRadius='none'
                                    height={'2.4rem'}
                                    // borderColor='#9E9E9E'
                                >
                                    Created at
                                </MenuButton>
                                <MenuList fontSize={12} minWidth={'180px'}>
                                    <MenuItem
                                    onClick={sortRecentFirst}
                                    >Recent first</MenuItem>
                                    <MenuItem
                                    onClick={sortOldestFirst}
                                    >Oldest first</MenuItem>
                                </MenuList>
                            </Menu>
                        </HStack>
                    </Flex>
                    <Box width='100%'>
                        <TableContainer>
                            <Table variant='simple'>
                                <Thead mb='10px' >
                                    <Tr pb='10px' borderBottom='1px solid' borderColor='#D5D5D5'>
                                        <Th textTransform='none'>Role Id</Th>
                                        <Th textTransform='none'>Role Name</Th>
                                        <Th textTransform='none'>Authorization Level</Th>
                                        <Th textTransform='none'>Created Date</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        filteredRoles.map((each:any, index:number) => {
                                            return (
                                                <Tr bg='white' key={index}>
                                                    <Td >
                                                        <Text>{each.id}</Text>
                                                    </Td>
                                                    <Td >
                                                        <Text>{each.name}</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text>Enterprise</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text>{moment(each.created_at).format('MMMM Do YYYY, h:mm:ss a')}</Text>
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                    }
                                    
                                </Tbody>

                            </Table>
                        </TableContainer>
                    </Box>
                </Box>

            </Box>
        </Flex>
        }
        </>
  )
}

export default Roles